<div class="breadcrumbs__timeline">
  <ng-content select="qe-breadcrumbs-step"></ng-content>

</div>
